export default __webpack_public_path__ + "static/media/size_guide.668eff20.jpg";